import { FullPageLoader } from 'components/FullPageLoader';
import { SearchTabs } from './components/SearchTabs';
import { SupportTicketForm } from './components/SupportTicketForm';
import { TicketsTable } from './components/TicketsTable';
import { useTicketsStore } from 'views/store/useTicketsStore';

export const SupportTicket = () => {
  const { loading } = useTicketsStore();

  return (
    <>
      {loading && <FullPageLoader />}

      <div className="p-4">
        <SupportTicketForm />

        <SearchTabs />

        <TicketsTable />
      </div>
    </>
  );
};
